<div mat-dialog-container>

  <form [formGroup]="erstelleAufgabeForm"
        class="erstelleAufgabeForm">

    <div mat-dialog-title style="display: flex; flex-direction: row;">
      <div class="dialog-header">Neuer Vorgang</div>
      <div class="close" style="margin-left: auto;">
        <button matMiniFab
                mat-dialog-close="close-x-button"
                data-qa="close-erstelle-aufgabe-dialog-button"
                type="button"
                [disabled]="uploading"
        >
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        </button>
      </div>
    </div>

    <div mat-dialog-content>
      <div class="form-field-row">
        <div class="item">
          <mat-form-field id="aufgabenTyp">
            <mat-label>Vorgangstyp</mat-label>
            <mat-select
              (valueChange)="aufgabeTypeChanged()"
              formControlName="type"
              required>
              @for (type of vorgangsTyps; track type) {
                <mat-option
                  [value]=type>{{ type | aufgabeTypeReadable }}
                </mat-option>
              }
            </mat-select>
            <mat-error>
              Bitte wählen Sie einen Typ aus
            </mat-error>
          </mat-form-field>
        </div>

        <div class="item">
          <mat-form-field (click)="picker.open()">
            <input
              [matDatepicker]="picker"
              [min]="minFristDate"
              formControlName="frist"
              id="frist"
              matInput
              name="frist"
              required/>
            @if (erstelleAufgabeForm.controls['type'].value === vorgangsTyps[0]) {
              <mat-label
              >Frist
              </mat-label>
            } @else {
              <mat-label>Datum</mat-label>
            }

            <mat-datepicker-toggle [for]="picker" matSuffix>
              <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

            @if (erstelleAufgabeForm.controls['frist']?.errors?.required) {
              <mat-error>
                Bitte wählen Sie eine Frist / ein Datum aus
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="form-field-row">
        <mat-form-field class="full-width">
          <mat-label>Name</mat-label>
          <input
            formControlName="name"
            id="aufgabeName"
            matInput
            maxLength="60"
            name="name"
            data-qa="aufgabeName"
            required/>
          <mat-hint align="end"
                    data-qa="aufgabeNameTextLengthCounter">{{ erstelleAufgabeForm.controls['name']?.value?.length }} /
            60
          </mat-hint>
          @if (erstelleAufgabeForm.controls['name']?.errors?.required) {
            <mat-error>
              Bitte vergeben Sie einen eindeutigen Namen
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field-row">

        <mat-form-field class="full-width">
          <mat-label>Kurzbeschreibung</mat-label>
          <textarea
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMaxRows="4"
            cdkAutosizeMinRows="2"
            cdkTextareaAutosize
            formControlName="kurzbeschreibung"
            id="aufgabeKurzbeschreibung"
            data-qa="kurzbeschreibung"
            matInput
            maxlength="1000"
            name="kurzbeschreibung">
          </textarea>
          <mat-hint align="end"
                    data-qa="aufgabeKurzbeschreibungTextLengthCounter">{{ erstelleAufgabeForm.controls['kurzbeschreibung']?.value?.length }}
            / 1000
          </mat-hint>
        </mat-form-field>
      </div>
      @if (!uploading) {
        <ufla-file-upload [multiple]="true"
                          [validators]="fileValidatorOptions"
                          (filesChange)="onFileUploadChanges()"
                          formControlName="file">
          @if (isFileError()) {
            <mat-error>Die ausgewählte Datei ist zu groß, die maximale Größe beträgt 150MB.</mat-error>
          }
        </ufla-file-upload>
      }

      <!-- display upload progress -->
      @if (uploading) {
        <div class="progress">
          <mat-label class="padding-left">Lade hoch...</mat-label>
          <mat-progress-bar [value]="uploadProgress" mode="determinate"></mat-progress-bar>
          @if (numberOfFilesToUpload > 1) {
            <div>{{ numberOfUploadedFiles }} von {{ numberOfFilesToUpload }}</div>
          }
        </div>
      }

      @if (!authenticationService.isUenb(uflaUser)) {
        <section>
          <mat-radio-group
            (ngModelChange)="aufgabeOrgaTypeChanged($event)"
            aria-labelledby="orgaTypeLabel"
            formControlName="orgaTypeLabel"
            id="orgaType"
            name="orgaType"
            required>
            <mat-label class="bold" id="orgaTypeLabel">Empfänger des Vorgangs ist</mat-label>
            <mat-radio-button id="group-receiver-option" [value]="true" class="font-8A8784">Gruppe</mat-radio-button>
            <mat-radio-button id="single-receiver-option" [value]="false" class="font-8A8784">Einzelempfänger
            </mat-radio-button>
          </mat-radio-group>
          @if (orgaTypeBasedGroupReceiverSelection) {
            <div class="receiverGroupSelection"
                 formGroupName="zuweisungen">
              <!-- orgaTypeBasedGroupReceiverSelection -->
              <div class="form-field-row">
                <!-- ÜNB -->
                <mat-checkbox
                  color="primary"
                  formControlName="assignToOrgTypUenb"
                  id="assignToOrgTypUenb"
                  name="assignToOrgTypUenb">ÜNB
                </mat-checkbox>
                <!-- VNB -->
                <mat-checkbox
                  color="primary"
                  formControlName="assignToOrgTypVnb"
                  id="assignToOrgTypVnb"
                  name="assignToOrgTypVnb">VNB
                </mat-checkbox>
                <!-- nVNB nicht integriert -->
                <mat-checkbox
                  color="primary"
                  formControlName="assignToOrgTypnVnbNichtIntegriert"
                  name="assignToOrgTypnVnbNichtIntegriert">nVNB nicht integriert
                </mat-checkbox>
                <!-- nVNB teilintegriert -->
                <mat-checkbox
                  color="primary"
                  formControlName="assignToOrgTypnVnbTeilIntegriert"
                  name="assignToOrgTypnVnbTeilIntegriert">nVNB teilintegriert
                </mat-checkbox>
                <!-- nVNB vollintegriert -->
                <mat-checkbox
                  color="primary"
                  formControlName="assignToOrgTypnVnbVollIntegriert"
                  name="assignToOrgTypnVnbVollIntegriert">nVNB vollintegriert
                </mat-checkbox>
              </div>
            </div>
          } @else {
            <div class="receiverGroupSelectionSelect">
              <mat-form-field id="singleReceiverSelect" class="full-width">
                <mat-label>Einzelempfänger</mat-label>
                <mat-select
                  formControlName="einzelEmpfaengerOrgId">
                  @for (org of singleReceiverSelectionOrganisations$ | async; track org) {
                    <mat-option
                      [value]="org.id">
                      {{ org.name }} ({{ org.eicNummer }})
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </section>
      } @else {
        <section class="detailsWestnetz">
          <mat-label class="bold">Empfänger des Vorgangs ist</mat-label>
          <span>&nbsp;</span>Westnetz.
        </section>
      }

      @if (authenticationService.isVnb(uflaUser)) {
        <div class="email-toggles">
          <div>
            <div class="toggle-info-text">Möchten Sie diesen Vorgang mit der Amprion teilen?</div>
            <mat-slide-toggle formControlName="mitUenbTeilen" id="mitUenbTeilen" name="mitUenbTeilen">
              @if (erstelleAufgabeForm.controls['mitUenbTeilen'].value) {
                <mat-label>Ja</mat-label>
              } @else {
                <mat-label>Nein</mat-label>
              }
            </mat-slide-toggle>
          </div>
        </div>
      }

      <div class="email-toggles">
        <div>
          <div class="toggle-info-text">Möchten Sie nach Abschluss des Vorganges benachrichtigt werden?</div>
          <mat-slide-toggle formControlName="emailBenachrichtigungNachVorgangabschluss"
                            id="benachrichtigungNachAbschluss"
                            name="emailBenachrichtigungNachVorgangabschluss">
            @if (erstelleAufgabeForm.controls['emailBenachrichtigungNachVorgangabschluss'].value) {
              <mat-label
              >
                Ja
              </mat-label>
            } @else {
              <mat-label>Nein</mat-label>
            }
          </mat-slide-toggle>
        </div>
      </div>

      <div class="email-toggles">
        <div>
          <div class="toggle-info-text">E-Mail Benachrichtigung beim Anlegen und Löschen?</div>
          <mat-slide-toggle formControlName="emailBenachrichtigungSenden"
                            id="emailBenachrichtigungSenden"
                            name="emailBenachrichtigungSenden"
                            (change)="toggledEmailBenachrichtigungSenden($event)">
            @if (erstelleAufgabeForm.controls['emailBenachrichtigungSenden'].value) {
              <mat-label
              >
                Ja
              </mat-label>
            } @else {
              <mat-label>Nein</mat-label>
            }
          </mat-slide-toggle>
        </div>

        <div>
          <div class="toggle-info-text">E-Mail Erinnerung 30 und 7 Tage vor erreichen der Frist / des Datums senden?</div>
          <mat-slide-toggle formControlName="erinnerungsMailSenden" id="erinnerungsMailSenden"
                            data-qa="erinnerungsMailSenden"
                            name="erinnerungsMailSenden">
            @if (erstelleAufgabeForm.controls['erinnerungsMailSenden'].value) {
              <mat-label
              >
                Ja
              </mat-label>
            } @else {
              <mat-label>Nein</mat-label>
            }
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <div>
      <div mat-dialog-actions>
        <div>
          <button data-qa="abort-erstelle-aufgabe-dialog-button"
                  mat-dialog-close="close-abort-button"
                  type="button"
                  matButton="outlined"
          >
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Abbrechen
          </button>
          <button
            [disabled]="!erstelleAufgabeForm.valid"
            id="saveAufgabeButton"
            type="button"
            matButton="filled"
            (click)="saveAufgabe()"
          >
            <mat-icon>save</mat-icon>
            Speichern
          </button>
        </div>
      </div>
    </div>
  </form>

  <ng-template #errorDialog>
    <h2 matDialogTitle>
      <mat-icon color='warn'>error</mat-icon>
      Fehler
    </h2>
    @if (errorMessage) {
      <p>{{ errorMessage }}</p>
    }
    <p matDialogContent>Änderungen konnten nicht gespeichert werden!</p>
    <mat-dialog-actions>
      <button matButton="filled" matDialogClose="error">
        <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        Verstanden
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
